import { getJsonApiEntities } from './generic'

export const getCurrentStoryId = (state) => state.currentStoryId

export const getStoriesMeta = (state) => {
  const jsonApiEntities = getJsonApiEntities(state)
  return jsonApiEntities.meta && jsonApiEntities.meta.story
    ? jsonApiEntities.meta.story
    : {}
}

export const getStories = (state) =>
  state.jsonApiEntities && state.jsonApiEntities.story

export const getStory = (state, storyId) =>
  state.jsonApiEntities &&
  state.jsonApiEntities.story &&
  state.jsonApiEntities.story[storyId]
